import React from "react";

import "./sponsored-tag.m.css";

const sponsoredTag = () => {
  return <div styleName="wrapper">This article is part of a featured content programme.</div>;
};

export default sponsoredTag;
